if (!customElements.get('scrolling-content')) {
  customElements.define(
    'scrolling-content',
    class ScrollingContent extends HTMLElement {
      static observedAttributes = ['data-playing'];
      constructor() {
        super();
      }

      connectedCallback() {
        this.playPause = this.querySelector('play-pause-button');
        this.speed = this.dataset.speed * 10000;
        this.dataset.playing = true;
        this.animated = [];
        this.timer = null;
        this.createElements();

        const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

        if (isReduced) this.dataset.playing = false;

        this.observer = new IntersectionObserver(
          ([e]) => {
            if (e.isIntersecting) {
              if (this.dataset.playing === 'true') {
                this.animated.forEach((el) => el.play());
              }
            } else {
              this.pauseItems();
            }
          },
          {
            threshold: [0],
          }
        );
        this.observer.observe(this);
        window.addEventListener('resize', window.utils.throttle(this.createElements.bind(this), 300));

        this.addEventListener('mouseenter', () => {
          this.timer = setTimeout(() => {
            this.pauseItems();
          }, 100);
        });

        this.addEventListener('mouseleave', () => {
          clearTimeout(this.timer);
          if (this.dataset.playing === 'true') {
            this.animated.forEach((el) => el.play());
          }
        });

        this.addEventListener('focusin', () => {
          this.pauseItems();
        });

        this.addEventListener('focusout', () => {
          if (this.dataset.playing === 'true') {
            this.animated.forEach((el) => el.play());
          }
        });

        this.playPause.addEventListener('click', () => {
          if (this.dataset.playing === 'true') {
            this.dataset.playing = false;
          } else {
            this.dataset.playing = true;
          }
        });
      }

      createElements() {
        if (this.clientWidth != this.width) {
          this.width = this.clientWidth;
          const items = this.querySelectorAll('.scrolling-content__items');
          const itemsWidth = items[0].clientWidth;
          if (itemsWidth < 1) return;
          let clones = Math.ceil((this.width - items.length * itemsWidth) / itemsWidth + 1);

          for (let i = 1; i <= clones; ++i) {
            const node = items[0].cloneNode(true);
            node.id = `${node.id}-${i}`;
            node.setAttribute('aria-hidden', true);
            const links = node.querySelectorAll('a');
            links.forEach((link) => {
              link.setAttribute('tabindex', '-1');
            });
            this.appendChild(node);
          }

          this.playOrPauseItems();
        }
      }

      playOrPauseItems() {
        let transform = [];
        if (document.dir === 'rtl') {
          transform = ['translateX(0)', 'translateX(100%)'];
          if (this.dataset.direction === 'right') {
            transform = ['translateX(100%)', 'translateX(0)'];
          }
        } else {
          transform = ['translateX(0)', 'translateX(-100%)'];
          if (this.dataset.direction === 'right') {
            transform = ['translateX(-100%)', 'translateX(0)'];
          }
        }
        const items = this.querySelectorAll('.scrolling-content__items');
        if (this.dataset.playing === 'true') {
          items.forEach((el, i) => {
            const animation = el.animate(
              { transform },
              { duration: this.speed, easing: 'linear', iterations: Infinity }
            );
            animation.id = `${this.id}-${i}`;
            this.animated = [...this.animated, animation];
          });
        }
      }

      pauseItems() {
        this.animated.forEach((el) => {
          el.pause();
        });
        const links = this.querySelectorAll('a');
        const ids = [];
        links.forEach((link) => {
          const id = link.parentElement.dataset.blockId;
          if (ids.includes(id)) {
            link.setAttribute('tabindex', '-1');
            return;
          }
          if (window.utils.isInViewport(link)) {
            link.removeAttribute('tabindex');
            ids.push(id);
          } else {
            link.setAttribute('tabindex', '-1');
          }
        });
        const items = this.querySelectorAll('.scrolling-content__items');
        items.forEach((item) => {
          let hasActive = false;
          const links = item.querySelectorAll('a');
          links.forEach((link) => {
            if (link.getAttribute('tabindex') !== '-1') hasActive = true;
          });
          if (hasActive) {
            item.removeAttribute('aria-hidden');
          } else {
            item.setAttribute('aria-hidden', true);
          }
        });
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-playing') {
          this.playPause.setAttribute('data-playing', newValue);
          if (newValue === 'false') {
            this.pauseItems();
          } else {
            this.animated?.forEach((el) => el.play());
          }
        }
      }
    }
  );
}
